import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { injectFlags } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'class()',
  },
  template: `
    @if (flags().purchaseOrders) {
      <span (click.prevent.stop)="onLinkClick()" class="aux-link" [attr.data-pendo-id]="pendoTag">
        {{ label() }}
      </span>
    } @else {
      {{ label() }}
    }
  `,
})
export class PurchaseOrdersLink {
  router = inject(Router);

  flags = injectFlags({
    purchaseOrders: 'tab_purchase_orders',
  });

  class = input<string>();
  label = input<string>('');

  pendoTag = 'invoices-redirect-to-po';

  onLinkClick() {
    void this.router.navigate([
      `/${ROUTING_PATH.BUDGET.INDEX}/${ROUTING_PATH.BUDGET.PURCHASE_ORDERS}`,
    ]);
  }
}
